// ─── DATE STATUS HELPERS ──────────────────────────────────────────────────────
// Pure functions used by list views to compute dynamic status badges
// (overdue / due soon / stale) at render time. See GRC_UI_PATTERNS.md §27.
//
// Today's date is read fresh on each call — never cached — so a list left open
// across midnight stays correct on the next render.

export const STALE_THRESHOLD_DAYS = 7;

function todayLocalYmd() {
  const now = new Date();
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

function addDaysYmd(ymd, days) {
  const [y, m, d] = ymd.split('-').map(n => parseInt(n, 10));
  const dt = new Date(y, m - 1, d);
  dt.setDate(dt.getDate() + days);
  const ny = dt.getFullYear();
  const nm = String(dt.getMonth() + 1).padStart(2, '0');
  const nd = String(dt.getDate()).padStart(2, '0');
  return `${ny}-${nm}-${nd}`;
}

export function dateStatus(dateStr) {
  if (dateStr === null || dateStr === undefined || dateStr === '') return null;
  if (typeof dateStr !== 'string') return null;
  const today = todayLocalYmd();
  const target = dateStr.slice(0, 10);
  if (target < today) return 'overdue';
  const horizon = addDaysYmd(today, 30);
  if (target <= horizon) return 'soon';
  return null;
}

export function incidentStaleness(incident) {
  if (!incident) return null;
  if (incident.status === 'Resolved' || incident.status === 'Closed') return null;
  const log = Array.isArray(incident.changeLog) ? incident.changeLog : [];
  let referenceTs = null;
  for (let i = log.length - 1; i >= 0; i--) {
    const entry = log[i];
    if (entry && entry.field === 'status' && entry.timestamp) {
      referenceTs = entry.timestamp;
      break;
    }
  }
  if (!referenceTs) referenceTs = incident.createdAt;
  if (!referenceTs) return null;
  const ref = new Date(referenceTs);
  if (isNaN(ref.getTime())) return null;
  const elapsedMs = Date.now() - ref.getTime();
  const elapsedDays = Math.floor(elapsedMs / (24 * 60 * 60 * 1000));
  return elapsedDays > STALE_THRESHOLD_DAYS ? 'stale' : null;
}
